import React from "react";
/* eslint-disable no-unused-vars */
import { Switch, Route } from 'react-router-dom';
import Helmet from 'react-helmet';
import Home from '../Home/Home';
import { WindowEventHandler } from "../../components/WindowEventHandler/WindowEventHandler";
import {Favicomatic} from "../../components/Favicomatic/Favicomatic";
import "./app.scss";

export class App extends React.Component
{
	render()
	{
		return (
				<div className="off-canvas-wrapper-inner" data-off-canvas-wrapper>
					<Helmet>
						<meta charset="UTF-8" />
    				<meta name="theme-color" content="#000000" />
						<meta name="viewport"
									content="width=device-width, shrink-to-fit=no, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"/ >
						<meta http-equiv="X-UA-Compatible" content="ie=edge" />
          	<meta content="text/html; charset=utf-8" http-equiv="content-type" />
						<link href="https://fonts.googleapis.com/css?family=Montserrat" rel="stylesheet" />
					</Helmet>
					<Favicomatic />
					<WindowEventHandler scroll resize load />
					<div className="off-canvas-content" data-off-canvas-content >
						<Switch>
							<Route component={Home} />
						</Switch>
					</div>
				</div>
		);
	}
}